export const VERTIFY_STATUS = {
  WAITING: 'WAITING',
  CERTIFIED: 'CERTIFIED',
  INVALID: 'INVALID'
};

export const WITHDRAW_STATUS = {
  ING: 'ING',
  OK: 'OK',
  FAIL: 'FAIL'
};
export const STATUS = {
  /**
   * reviewing:
   * 审核中
   */
  REVIEWING: 'REVIEWING',
  /**
   * reviewed: * reviewed:
   * 审核通过 * 审核通过
   */
  REVIEWED: 'REVIEWED',
  /**
   * transferred: * transferred:
   * 已转账 * 已转账
   */
  TRANSFERRED: 'TRANSFERRED',
  /**
   * transfer_failed: * transfer_failed:
   * 转账失败 * 转账失败
   */
  TRANSFER_FAILED: 'TRANSFER_FAILED',
  /**
   * review_failed: * review_failed:
   * 审核失败 * 审核失败
   */
  REVIEW_FAILED: 'REVIEW_FAILED'
};
export const STATUS_ZH = {
  /**
   * reviewing:
   * 审核中
   */
  REVIEWING: '审核中',
  /**
   * reviewed: * reviewed:
   * 审核通过 * 审核通过
   */
  REVIEWED: '审核通过',
  /**
   * transferred: * transferred:
   * 已转账 * 已转账
   */
  TRANSFERRED: '已转账',
  /**
   * transfer_failed: * transfer_failed:
   * 转账失败 * 转账失败
   */
  TRANSFER_FAILED: '转账失败',
  /**
   * review_failed: * review_failed:
   * 审核失败 * 审核失败
   */
  REVIEW_FAILED: '审核失败'
};
